import { AppShell } from '@/components/shell/AppShell';
import { AuthGuard } from '@/lib/auth/AuthGuard';
import { tenantCommands, tenantNav } from '@/lib/nav/tenant';

export function TenantLayout() {
  return (
    <AuthGuard audience="tenant">
      <AppShell audience="tenant" nav={tenantNav} commands={tenantCommands} />
    </AuthGuard>
  );
}
